// 'use client';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ReactNode } from 'react';
import {darkTheme, lightTheme} from './theme';

// Prevent Emotion style reordering
const cache = createCache({ key: 'mui', prepend: true });

interface ThemeRegistryProps {
    children: ReactNode;
}

export default function ThemeRegistry({ children }: ThemeRegistryProps) {
    const mode = 'light'; // You can change this to 'dark' to switch themes
    return (
        <CacheProvider value={cache}>
            <ThemeProvider theme={mode === 'light' ? lightTheme : darkTheme}>
            <CssBaseline />
                {children}
            </ThemeProvider>
        </CacheProvider>
    );
}
